import { Loader2, Upload } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

export function DeliverDialog({ open, onOpenChange, selectedOrder, fileInputRef, handleFileUpload, uploadingId }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626]">
        <DialogHeader>
          <DialogTitle>Deliver Dubplate</DialogTitle>
          <DialogDescription>Upload the audio file for {selectedOrder?.user_name}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {selectedOrder && (
            <div className="p-4 bg-surface-highlight rounded-lg">
              <p className="text-sm text-[#A1A1AA] mb-2">Customer's message:</p>
              <p className="text-sm">{selectedOrder.message}</p>
            </div>
          )}
          <div className="border-2 border-dashed border-[#262626] rounded-xl p-8 text-center hover:border-lime transition-colors">
            <input ref={fileInputRef} type="file" accept=".mp3,.wav,.m4a,.aac,audio/*" onChange={handleFileUpload} className="hidden" id="file-upload" data-testid="file-upload-input" />
            <label htmlFor="file-upload" className="cursor-pointer">
              {uploadingId ? (
                <div className="flex flex-col items-center">
                  <Loader2 className="w-8 h-8 animate-spin text-lime mb-2" />
                  <span className="text-sm">Uploading...</span>
                </div>
              ) : (
                <div className="flex flex-col items-center">
                  <Upload className="w-8 h-8 text-[#666] mb-2" />
                  <span className="text-sm text-[#A1A1AA]">Click to upload audio file</span>
                  <span className="text-xs text-[#666] mt-1">MP3, WAV, M4A, AAC</span>
                </div>
              )}
            </label>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
